import { IAppState } from '../../../store/appState';
import { BuildingFeatures } from '../../../store/reducers/merkmale.reducer';

export const selectMerkmale = (state: IAppState): BuildingFeatures => state.buildingFeatures;

export const isKellerVorhandenSelectable = (state: IAppState): boolean => state.buildingFeatures.basement;

export const isWohnraumInKellerVorhanden = (state: IAppState): boolean =>
  state.buildingFeatures.basementWithLivingSpace;

export const isSchwimmbadVorhanden = (state: IAppState): boolean => state.buildingFeatures.pool;

export const isSchwimmbadStandortSelected = (state: IAppState): boolean => {
  const m = state.buildingFeatures;
  return m.poolIndoors || m.poolOutdoors;
};

export const isAussenpoolInHtsSelected = (state: IAppState): boolean => state.buildingFeatures?.aussenpoolInHts === true;

export const isLeerstand = (state: IAppState): boolean => state.buildingFeatures.notPermanentlyOccupied;
export const isDenkmalgeschuetzt = (state: IAppState): boolean => state.buildingFeatures.heritageProtection;

export const isFeuerrohbau = (state: IAppState): boolean => state.buildingFeatures.fireShellConstruction;

export const GEBAEUDENUTZUNG_MERKMALE = ['vacationHome', 'rented', 'notPermanentlyOccupied', 'fireShellConstruction'] as const;
export const HEIZTECHNIK_MERKMALE = ['gasHeating', 'oilHeating', 'districtHeating', 'pelletHeating', 'geothermal', 'solarThermal', 'photovoltaic'] as const;
export const GEBAEUDE_BESONDERHEITEN = ['flatRoof', 'softRoofCovering', 'woodenHouse', 'basement', 'pool', 'heritageProtection'] as const;

export const isGebaeudenutzungSelected = (state: IAppState): boolean =>
  GEBAEUDENUTZUNG_MERKMALE.some(key => state.buildingFeatures[key]) ||
  state.buildingFeatures.noneApplies;

export const isHeiztechnikSelected = (state: IAppState): boolean =>
  HEIZTECHNIK_MERKMALE.some(key => state.buildingFeatures[key]) ||
  state.buildingFeatures.noHeatingApplies;

export const isBuildingSpecialFeaturesSelected = (state: IAppState): boolean =>
  GEBAEUDE_BESONDERHEITEN.some(key => state.buildingFeatures[key]) ||
  state.buildingFeatures.noBuildingSpecialFeaturesApplies;
